export const calculateTotalDiscountValue = (data: {
    discount_type: 'fixed' | 'percentage';
    discount_value: number;
    items: {
        product_name: string;
        discount_type: 'fixed' | 'percentage';
        discount_value: number;
        quantity: number;
        price: number;
    }[];
}): number => {
    let itemDiscountTotal = 0; // Sum of discounts from items that have their own discount
    let nonDiscountedSubtotal = 0; // Subtotal of items with NO item-level discount (order discount applies here)

    for (const item of data.items) {
        const itemSubtotal = item.price * item.quantity;
        const hasItemDiscount = item.discount_value > 0;

        if (hasItemDiscount) {
            // Calculate this item's own discount
            if (item.discount_type === 'fixed') {
                // Fixed discount: flat amount off the item subtotal (capped at subtotal)
                itemDiscountTotal += Math.min(
                    item.discount_value,
                    itemSubtotal,
                );
            } else if (item.discount_type === 'percentage') {
                // Percentage discount: percent of item subtotal
                itemDiscountTotal += (item.discount_value / 100) * itemSubtotal;
            }
        } else {
            // No item-level discount — this item is subject to the order-level discount
            nonDiscountedSubtotal += itemSubtotal;
        }
    }

    // Calculate the order-level discount, applied only to items without their own discount
    let orderDiscount = 0;
    if (data.discount_value > 0 && nonDiscountedSubtotal > 0) {
        if (data.discount_type === 'fixed') {
            // Fixed order discount: flat amount off the non-discounted subtotal (capped)
            orderDiscount = Math.min(
                data.discount_value,
                nonDiscountedSubtotal,
            );
        } else if (data.discount_type === 'percentage') {
            // Percentage order discount: percent of the non-discounted subtotal
            orderDiscount = (data.discount_value / 100) * nonDiscountedSubtotal;
        }
    }

    // Final discount = individual item discounts + order-level discount on eligible items
    const totalDiscount = itemDiscountTotal + orderDiscount;

    return totalDiscount;
};
